import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["rootTag"],
  _excluded2 = ["rootTag"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { DynamicFeatures } from '@shopee/react-native-sdk';
import { NativeModules, Platform } from 'react-native';
export var checkGAMediaSelectReady = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var MEDIA_SELECT_MODULE_NAME, _res$data, res, moduleList, mediaSelectModule;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            MEDIA_SELECT_MODULE_NAME = 'dfpluginshopee12';
            _context.prev = 1;
            if (!(Platform.OS === 'ios')) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", true);
          case 4:
            _context.next = 6;
            return DynamicFeatures.getDFModuleStatus({
              moduleNames: [MEDIA_SELECT_MODULE_NAME]
            });
          case 6:
            res = _context.sent;
            moduleList = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.modules;
            console.log('moduleList', moduleList);
            mediaSelectModule = moduleList === null || moduleList === void 0 ? void 0 : moduleList.find(function (module) {
              return module.moduleName === MEDIA_SELECT_MODULE_NAME && module.status === 2;
            });
            console.log('mediaSelectModule', mediaSelectModule);
            if (!mediaSelectModule) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("return", true);
          case 13:
            _context.next = 15;
            return DynamicFeatures.downloadDFModules({
              moduleNames: [MEDIA_SELECT_MODULE_NAME],
              progress: 1
            });
          case 15:
            return _context.abrupt("return", false);
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](1);
          case 20:
            return _context.abrupt("return", false);
          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 18]]);
  }));
  return function checkGAMediaSelectReady() {
    return _ref.apply(this, arguments);
  };
}();
export var useGAMediaSelect = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var isReady;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return checkGAMediaSelectReady();
          case 2:
            isReady = _context2.sent;
            if (!isReady) {
              _context2.next = 7;
              break;
            }
            return _context2.abrupt("return", NativeModules === null || NativeModules === void 0 ? void 0 : NativeModules.GAMediaSelect);
          case 7:
            return _context2.abrupt("return", null);
          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function useGAMediaSelect() {
    return _ref2.apply(this, arguments);
  };
}();
export var useMMCUploadSDKModule = function useMMCUploadSDKModule() {
  return (NativeModules === null || NativeModules === void 0 ? void 0 : NativeModules.MMCUploadSDKModule) || null;
};
export var UploadMediaSource;
(function (UploadMediaSource) {
  UploadMediaSource[UploadMediaSource["Both"] = 0] = "Both";
  UploadMediaSource[UploadMediaSource["Camera"] = 1] = "Camera";
  UploadMediaSource[UploadMediaSource["Album"] = 2] = "Album";
})(UploadMediaSource || (UploadMediaSource = {}));
export var MediaType;
(function (MediaType) {
  MediaType[MediaType["ImageAndVideo"] = 0] = "ImageAndVideo";
  MediaType[MediaType["Image"] = 1] = "Image";
  MediaType[MediaType["Video"] = 2] = "Video";
})(MediaType || (MediaType = {}));
export default {
  mediaSelect: function () {
    var _mediaSelect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(props) {
      var rootTag, rest, result, _GAMediaSelect$mediaS, GAMediaSelect, _ref3, data, errorMessage, error;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              rootTag = props.rootTag, rest = _objectWithoutProperties(props, _excluded);
              result = undefined;
              _context3.prev = 2;
              _context3.next = 5;
              return useGAMediaSelect();
            case 5:
              GAMediaSelect = _context3.sent;
              _context3.t1 = JSON;
              _context3.next = 9;
              return GAMediaSelect === null || GAMediaSelect === void 0 ? void 0 : (_GAMediaSelect$mediaS = GAMediaSelect.mediaSelect) === null || _GAMediaSelect$mediaS === void 0 ? void 0 : _GAMediaSelect$mediaS.call(GAMediaSelect, rootTag, JSON.stringify(rest));
            case 9:
              _context3.t2 = _context3.sent;
              _context3.t0 = _context3.t1.parse.call(_context3.t1, _context3.t2);
              if (_context3.t0) {
                _context3.next = 13;
                break;
              }
              _context3.t0 = {};
            case 13:
              _ref3 = _context3.t0;
              data = _ref3.data;
              errorMessage = _ref3.errorMessage;
              error = _ref3.error;
              result = {
                error: +!!error,
                errorMessage: errorMessage,
                errorType: error,
                data: data
              };
              _context3.next = 23;
              break;
            case 20:
              _context3.prev = 20;
              _context3.t3 = _context3["catch"](2);
              result = {
                error: 400,
                errorMessage: (_context3.t3 === null || _context3.t3 === void 0 ? void 0 : _context3.t3.toString()) || ''
              };
            case 23:
              return _context3.abrupt("return", result);
            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 20]]);
    }));
    function mediaSelect(_x) {
      return _mediaSelect.apply(this, arguments);
    }
    return mediaSelect;
  }(),
  mediaStartListeningForUploadProgress: function () {
    var _mediaStartListeningForUploadProgress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(rootTag) {
      var _GAMediaSelect$mediaS2;
      var GAMediaSelect, res;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return useGAMediaSelect();
            case 2:
              GAMediaSelect = _context4.sent;
              _context4.t1 = JSON;
              _context4.next = 6;
              return GAMediaSelect === null || GAMediaSelect === void 0 ? void 0 : (_GAMediaSelect$mediaS2 = GAMediaSelect.mediaStartListeningForUploadProgress) === null || _GAMediaSelect$mediaS2 === void 0 ? void 0 : _GAMediaSelect$mediaS2.call(GAMediaSelect, rootTag, JSON.stringify({}));
            case 6:
              _context4.t2 = _context4.sent;
              _context4.t0 = _context4.t1.parse.call(_context4.t1, _context4.t2);
              if (_context4.t0) {
                _context4.next = 10;
                break;
              }
              _context4.t0 = {};
            case 10:
              res = _context4.t0;
              return _context4.abrupt("return", res);
            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    function mediaStartListeningForUploadProgress(_x2) {
      return _mediaStartListeningForUploadProgress.apply(this, arguments);
    }
    return mediaStartListeningForUploadProgress;
  }(),
  mediaStopListeningForUploadProgress: function () {
    var _mediaStopListeningForUploadProgress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(rootTag) {
      var _GAMediaSelect$mediaS3;
      var GAMediaSelect, res;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return useGAMediaSelect();
            case 2:
              GAMediaSelect = _context5.sent;
              _context5.t1 = JSON;
              _context5.next = 6;
              return GAMediaSelect === null || GAMediaSelect === void 0 ? void 0 : (_GAMediaSelect$mediaS3 = GAMediaSelect.mediaStopListeningForUploadProgress) === null || _GAMediaSelect$mediaS3 === void 0 ? void 0 : _GAMediaSelect$mediaS3.call(GAMediaSelect, rootTag, JSON.stringify({}));
            case 6:
              _context5.t2 = _context5.sent;
              _context5.t0 = _context5.t1.parse.call(_context5.t1, _context5.t2);
              if (_context5.t0) {
                _context5.next = 10;
                break;
              }
              _context5.t0 = {};
            case 10:
              res = _context5.t0;
              return _context5.abrupt("return", res);
            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    function mediaStopListeningForUploadProgress(_x3) {
      return _mediaStopListeningForUploadProgress.apply(this, arguments);
    }
    return mediaStopListeningForUploadProgress;
  }(),
  mediaCleanUpWithTimestamp: function () {
    var _mediaCleanUpWithTimestamp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(rootTag, timestamp) {
      var _GAMediaSelect$mediaC;
      var GAMediaSelect, res;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return useGAMediaSelect();
            case 2:
              GAMediaSelect = _context6.sent;
              _context6.t1 = JSON;
              _context6.next = 6;
              return GAMediaSelect === null || GAMediaSelect === void 0 ? void 0 : (_GAMediaSelect$mediaC = GAMediaSelect.mediaCleanUpWithTimestamp) === null || _GAMediaSelect$mediaC === void 0 ? void 0 : _GAMediaSelect$mediaC.call(GAMediaSelect, rootTag, JSON.stringify({
                timestamp: timestamp
              }));
            case 6:
              _context6.t2 = _context6.sent;
              _context6.t0 = _context6.t1.parse.call(_context6.t1, _context6.t2);
              if (_context6.t0) {
                _context6.next = 10;
                break;
              }
              _context6.t0 = {};
            case 10:
              res = _context6.t0;
              return _context6.abrupt("return", res);
            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    function mediaCleanUpWithTimestamp(_x4, _x5) {
      return _mediaCleanUpWithTimestamp.apply(this, arguments);
    }
    return mediaCleanUpWithTimestamp;
  }(),
  mediaCancelUploadWithIds: function () {
    var _mediaCancelUploadWithIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(rootTag, ids) {
      var _GAMediaSelect$mediaC2;
      var GAMediaSelect, res;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return useGAMediaSelect();
            case 2:
              GAMediaSelect = _context7.sent;
              _context7.t1 = JSON;
              _context7.next = 6;
              return GAMediaSelect === null || GAMediaSelect === void 0 ? void 0 : (_GAMediaSelect$mediaC2 = GAMediaSelect.mediaCancelUploadWithIds) === null || _GAMediaSelect$mediaC2 === void 0 ? void 0 : _GAMediaSelect$mediaC2.call(GAMediaSelect, rootTag, JSON.stringify({
                ids: ids
              }));
            case 6:
              _context7.t2 = _context7.sent;
              _context7.t0 = _context7.t1.parse.call(_context7.t1, _context7.t2);
              if (_context7.t0) {
                _context7.next = 10;
                break;
              }
              _context7.t0 = {};
            case 10:
              res = _context7.t0;
              return _context7.abrupt("return", res);
            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    function mediaCancelUploadWithIds(_x6, _x7) {
      return _mediaCancelUploadWithIds.apply(this, arguments);
    }
    return mediaCancelUploadWithIds;
  }(),
  mediaStartUploadWithId: function () {
    var _mediaStartUploadWithId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(props) {
      var GAMediaSelect, rootTag, rest, result, _GAMediaSelect$mediaS4, _ref4, data, errorMessage, error;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return useGAMediaSelect();
            case 2:
              GAMediaSelect = _context8.sent;
              rootTag = props.rootTag, rest = _objectWithoutProperties(props, _excluded2);
              result = undefined;
              _context8.prev = 5;
              _context8.t1 = JSON;
              _context8.next = 9;
              return GAMediaSelect === null || GAMediaSelect === void 0 ? void 0 : (_GAMediaSelect$mediaS4 = GAMediaSelect.mediaStartUploadWithId) === null || _GAMediaSelect$mediaS4 === void 0 ? void 0 : _GAMediaSelect$mediaS4.call(GAMediaSelect, rootTag, JSON.stringify(rest));
            case 9:
              _context8.t2 = _context8.sent;
              _context8.t0 = _context8.t1.parse.call(_context8.t1, _context8.t2);
              if (_context8.t0) {
                _context8.next = 13;
                break;
              }
              _context8.t0 = {};
            case 13:
              _ref4 = _context8.t0;
              data = _ref4.data;
              errorMessage = _ref4.errorMessage;
              error = _ref4.error;
              result = {
                error: error,
                errorMessage: errorMessage,
                data: data
              };
              _context8.next = 23;
              break;
            case 20:
              _context8.prev = 20;
              _context8.t3 = _context8["catch"](5);
              result = {
                error: 400,
                errorMessage: (_context8.t3 === null || _context8.t3 === void 0 ? void 0 : _context8.t3.toString()) || ''
              };
            case 23:
              return _context8.abrupt("return", result);
            case 24:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[5, 20]]);
    }));
    function mediaStartUploadWithId(_x8) {
      return _mediaStartUploadWithId.apply(this, arguments);
    }
    return mediaStartUploadWithId;
  }(),
  mediaGetStatusWithId: function () {
    var _mediaGetStatusWithId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(rootTag, id) {
      var result, GAMediaSelect, _GAMediaSelect$mediaG, _ref5, data, errorMessage, error;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              result = undefined;
              _context9.next = 3;
              return useGAMediaSelect();
            case 3:
              GAMediaSelect = _context9.sent;
              _context9.prev = 4;
              _context9.t1 = JSON;
              _context9.next = 8;
              return GAMediaSelect === null || GAMediaSelect === void 0 ? void 0 : (_GAMediaSelect$mediaG = GAMediaSelect.mediaGetStatusWithId) === null || _GAMediaSelect$mediaG === void 0 ? void 0 : _GAMediaSelect$mediaG.call(GAMediaSelect, rootTag, JSON.stringify({
                id: id
              }));
            case 8:
              _context9.t2 = _context9.sent;
              _context9.t0 = _context9.t1.parse.call(_context9.t1, _context9.t2);
              if (_context9.t0) {
                _context9.next = 12;
                break;
              }
              _context9.t0 = {};
            case 12:
              _ref5 = _context9.t0;
              data = _ref5.data;
              errorMessage = _ref5.errorMessage;
              error = _ref5.error;
              result = {
                error: error,
                errorMessage: errorMessage,
                data: data
              };
              _context9.next = 22;
              break;
            case 19:
              _context9.prev = 19;
              _context9.t3 = _context9["catch"](4);
              result = {
                error: 400,
                errorMessage: (_context9.t3 === null || _context9.t3 === void 0 ? void 0 : _context9.t3.toString()) || ''
              };
            case 22:
              return _context9.abrupt("return", result);
            case 23:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[4, 19]]);
    }));
    function mediaGetStatusWithId(_x9, _x10) {
      return _mediaGetStatusWithId.apply(this, arguments);
    }
    return mediaGetStatusWithId;
  }(),
  imageUpload: function () {
    var _imageUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(props) {
      var biz, imgsPath, result, _MMCUploadSDKModule$u, MMCUploadSDKModule, uploadRes;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              biz = props.biz, imgsPath = props.imgsPath;
              result = undefined;
              _context10.prev = 2;
              MMCUploadSDKModule = useMMCUploadSDKModule();
              _context10.t1 = JSON;
              _context10.next = 7;
              return MMCUploadSDKModule === null || MMCUploadSDKModule === void 0 ? void 0 : (_MMCUploadSDKModule$u = MMCUploadSDKModule.upload) === null || _MMCUploadSDKModule$u === void 0 ? void 0 : _MMCUploadSDKModule$u.call(MMCUploadSDKModule, JSON.stringify({
                biz: biz,
                imgsPath: imgsPath
              }));
            case 7:
              _context10.t2 = _context10.sent;
              _context10.t0 = _context10.t1.parse.call(_context10.t1, _context10.t2);
              if (_context10.t0) {
                _context10.next = 11;
                break;
              }
              _context10.t0 = {};
            case 11:
              uploadRes = _context10.t0;
              result = uploadRes;
              _context10.next = 18;
              break;
            case 15:
              _context10.prev = 15;
              _context10.t3 = _context10["catch"](2);
              result = {
                error: 400,
                errorMessage: (_context10.t3 === null || _context10.t3 === void 0 ? void 0 : _context10.t3.toString()) || ''
              };
            case 18:
              return _context10.abrupt("return", result);
            case 19:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[2, 15]]);
    }));
    function imageUpload(_x11) {
      return _imageUpload.apply(this, arguments);
    }
    return imageUpload;
  }()
};